import { ReportSubscription } from '@/@types/report-subscription';
import { User } from '@/@types/user';
import { Modal } from '@/components/common';
import { Close } from '@mui/icons-material';
import { Box, DialogTitle, IconButton, LinearProgress } from '@mui/material';
import {
  ReportSubscriptionForm,
  ReportSubscriptionFormData,
} from '../ReportSubscriptionForm';
import { ReportSubscriptionFormPlaceholder } from '../ReportSubscriptionForm/ReportSubscriptionFormPlaceholder';

interface ReportSubscriptionModalProps {
  reportSubscription?: ReportSubscription;
  users: User[];
  isOpen: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: ReportSubscriptionFormData) => void;
}

export function ReportSubscriptionModal({
  reportSubscription,
  users,
  isOpen,
  isLoading,
  isFetching,
  isSubmitting,
  onClose,
  onSubmit,
}: ReportSubscriptionModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle id="scroll-dialog-title" sx={{ p: 2 }}>
        {reportSubscription ? 'Alterar Agendamento' : 'Novo Agendamento'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {isSubmitting || isFetching ? (
        <Box>
          <LinearProgress />
        </Box>
      ) : null}
      {isLoading ? (
        <ReportSubscriptionFormPlaceholder />
      ) : (
        <ReportSubscriptionForm
          reportSubscription={reportSubscription}
          users={users}
          isLoading={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
}
